import { render, staticRenderFns } from "./resumenCarrito.vue?vue&type=template&id=721b1b16&scoped=true&"
import script from "./resumenCarrito.vue?vue&type=script&lang=js&"
export * from "./resumenCarrito.vue?vue&type=script&lang=js&"
import style0 from "./resumenCarrito.vue?vue&type=style&index=0&id=721b1b16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721b1b16",
  null
  
)

export default component.exports